import React from "react";

export default function TextArea({
  elem,
  commentVisited,
  data,
  setCommentVisited,
  setData,
  messageError,
}) {
  return (
    <div>
      <label for="comentario">
        {elem?.label}
         <span className="obligatory"> *</span>
      </label>
      <input
        type="text"
        className={`${
          commentVisited ? (data?.comment ? "" : "formError") : ""
        } form-control input-sm textInput especialGroup formHover`}
        id={elem?.id}
        name={elem?.id}
        key={elem?.id}
        aria-describedby="comentarioHelp"
        placeholder={elem?.placeholder}
        onClick={() => setCommentVisited(true)}
        onChange={(e) =>
          setData({
            ...data,
            comment: e.target.value,
          })
        }
        value={data?.comment}
      ></input>
      {commentVisited && !data?.comment ? (
        <span className="errorMessage">
          {data?.comment ? "" : messageError}
        </span>
      ) : (
        ""
      )}
      <hr></hr>
    </div>
  );
}
